import { useState } from 'react';
import {
  FaqSimplifiedItem,
  FaqSimplified as FaqSimplifiedProps,
  SanityKeyed
} from 'types/studio/studio';
import { navigationClickEvent } from 'analytics/events/studio';
import { FaqQuestion } from './FaqQuestion/FaqQuestion';
import { CommonSectionProps } from '../../types';

const FaqSimplified = ({
  _key: key,
  _type: sectionType,
  isFirstQuestionCollapsed,
  questions
}: SanityKeyed<FaqSimplifiedProps> & CommonSectionProps) => {
  const [selected, setSelected] = useState(isFirstQuestionCollapsed ? null : questions[0]._key);

  const handleToggleQuestion = ({
    itemKey,
    itemHeadline
  }: {
    itemKey: string;
    itemHeadline: string;
  }) => {
    if (selected !== itemKey)
      navigationClickEvent({
        location: sectionType,
        navigationType: 'accordion',
        clickText: itemHeadline
      });
    setSelected((prev) => (prev === itemKey ? null : itemKey));
  };

  return (
    <div id={key}>
      {questions.map((item: SanityKeyed<FaqSimplifiedItem>) => (
        <FaqQuestion
          key={item._key}
          {...item}
          isOpen={item._key === selected}
          onToggle={() =>
            handleToggleQuestion({
              itemKey: item._key,
              itemHeadline: item.qHeadline
            })
          }
        />
      ))}
    </div>
  );
};

export default FaqSimplified;
